import { z } from 'zod';
import { ArgoConnectionKindEnum } from '../db';

export const connectionTerminatorSchema = z.union([ z.literal('none'), z.literal('null') ]);
export type ConnectionTerminator = z.infer<typeof connectionTerminatorSchema>;

export const torqueToolConnectionConfigSchema = z.object({
    kind: z.literal(ArgoConnectionKindEnum.TorqueTool),
    details: z.object({
        ip: z.string(),
        port: z.number(),
        terminator: connectionTerminatorSchema,
    }),
});
export type TorqueToolConnectionConfig = z.infer<typeof torqueToolConnectionConfigSchema>;
